module.exports = __webpack_public_path__ + "img/LH.8036f062.jpg";